module.exports = __webpack_public_path__ + "static/Axiforma-Bold-7b06c977d8c546517d6c65d1690ee939.eot";